const locale = {
    placeholder: 'בחר שעה',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/he_IL.tsx